import React from 'react';
import { TicketApi } from '../../../redux/api/TicketApi';
import { useParams } from 'react-router-dom';
import TicketPager from './Sections/TicketPager';

const TicketConfigTest: React.FC = () => {
    const { ticketId } = useParams()
    const { data: config } = TicketApi.useGetTicketConfigQuery(parseInt(ticketId), { skip: !ticketId, pollingInterval: 10000 });
    return (
        <div>
            <h1>Ticket Config Test</h1>
            {/* <TicketPager /> */}
            <p>This is the TicketConfigTest component.</p>
        </div>
    );
};

export default TicketConfigTest;